import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
   providedIn: 'root'
})
export class RequisitionDataService {

   constructor(private httpClient: HttpClient, private configService: ConfigService) {
   }

   public getList(start, count, sortBy, sortDirection, filters) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/GetList?start=${start}&length=${count}&sortBy=${sortBy}&sortDirection=${sortDirection}&filters=${JSON.stringify(filters)}`;
      return this.httpClient.get(url);
   }

   public getDetail(id) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition?id=${id}`;
      return this.httpClient.get(url);
   }

   public getListForPackage(packageId) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/GetListForPackage?packageId=${packageId}`;
      return this.httpClient.get(url);
   }

   public getFilters() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/GetFilters`;
      return this.httpClient.get(url);
   }

  public isPastStability(accession) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/IsPastStability?accession=${accession}`;
    return this.httpClient.get(url);
  }

   public getEmptyModel() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/GetEmptyModel`;
      return this.httpClient.get(url);
   }

   public getAccessionExists(accession) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/AccessionExists?accession=${accession}`;
      return this.httpClient.get(url);
   }

   public getRequisitionForAccession(accession) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/GetByAccession?accession=${accession}`;
      return this.httpClient.get(url);
   }

   public getRequisitionIntakeForAccession(accession) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/GetForIntakeByAccession?accession=${accession}`;
      return this.httpClient.get(url);
   }

   public getMTOrder(accession) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/GetOrderFromMedTek21?accession=${accession}`;
      return this.httpClient.get(url);
   }

   public UpdateMedTekFromRequisition(medtekdto) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/UpdateMedTekFromRequisition`;
      return this.httpClient.put(url, medtekdto);
   }

   public updateMTRequisition(accession) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/UpdateRequisitionFromMedTek21?accession=${accession}`;
      return this.httpClient.get(url);
   }

   public sendRequisitionToIntegrations(accession, allowUpdate) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/SendRequisitionToIntegrations?accession=${accession}&allowUpdate=${allowUpdate}`;
      return this.httpClient.get(url);
   }

   public rejectPackageDuplicates(packageId, accession) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/RejectPackageDuplicates?packageId=${packageId}&serialNumber=${accession}`;
      return this.httpClient.get(url);
   }

   public attemptToResolveRequisitionExceptions(accession) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/AttemptToResolveRequisitionExceptions?accession=${accession}`;
      return this.httpClient.get(url);
   }

   public attemptToResolveRequisitionExceptionsPackage(id) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/AttemptToResolveRequisitionExceptionsForPackage?packageId=${id}`;
      return this.httpClient.get(url);
   }

   public attemptToResolveRequisitionExceptionsAll() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/AttemptToResolveRequisitionExceptionsAll`;
      return this.httpClient.get(url);
   }

   public rejectRequisition(accession, rejectionType, description) {
      let requisitionRejection: any = {};
      requisitionRejection.Accession = accession;
      requisitionRejection.RejectionTypes = rejectionType;
      requisitionRejection.Description = description;
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/RejectRequisition`;
      return this.httpClient.post(url, requisitionRejection);
  }

   public unrejectRequisition(rejectDTO) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/Unreject`;
      return this.httpClient.post(url, rejectDTO);
   }

   public deleteRequisition(id) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/delete?id=${id}`;
      return this.httpClient.get(url);
   }

   public saveRequisition(req) {
      if (req.Id === 0) {
         let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition`;
         return this.httpClient.post(url, req);
      } else {
         let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition?id=${req.Id}`;
         return this.httpClient.put(url, req);
      }
   }

   public updateRequisition(req) {
      if (req.Id === 0) return;
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Requisition/?id=${req.Id}`;
      return this.httpClient.put(url, req);
   }

}
